module.exports = __webpack_public_path__ + "static/media/icon-pencil.729876a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-pencil.svg
// module id = 379
// module chunks = 0